module.exports = __webpack_public_path__ + "static/media/BRB.fd3e405c.svg";